export const sortOptions = [
  { label: "Date (latest first)", value: "latest" },
  { label: "Date (oldest first)", value: "oldest" },
  { label: "Alphabet (A-Z)", value: "a-z" },
  { label: "Alphabet (Z-A)", value: "z-a" },
];
